import { createTheme } from '@mui/material/styles';
import variables from '~/components/common/globalStyles/_variables.module.scss';

export const appTheme = createTheme({
  typography: {
    fontFamily: variables.font,
    fontSize: 11,
    body1: {
      fontSize: '12px',
    },
    button: {
      textTransform: 'none',
    },
    h1: {
      lineHeight: '100%',
    },
    h2: {
      lineHeight: '100%',
    },
    h3: {
      lineHeight: '100%',
    },
    h4: {
      lineHeight: '100%',
    },
    h5: {
      lineHeight: '100%',
    },
    h6: {
      lineHeight: '100%',
    },
  },
  palette: {
    primary: {
      light: variables.colorPrimary,
      main: variables.colorPrimary,
      dark: variables.colorPrimary,
      contrastText: '#FFFFFF',
    },
    secondary: {
      light: variables.colorSecondary,
      main: variables.colorSecondary,
      dark: variables.colorSecondary,
      contrastText: '#FFFFFF',
    },
    info: {
      light: variables.colorInfo,
      main: variables.colorInfo,
      dark: variables.colorInfo,
      contrastText: '#FFFFFF',
    },
    success: {
      light: variables.colorSuccess,
      main: variables.colorSuccess,
      dark: variables.colorSuccess,
      contrastText: '#FFFFFF',
    },
    error: {
      light: variables.colorError,
      main: variables.colorError,
      dark: variables.colorError,
      contrastText: '#FFFFFF',
    },
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontWeight: 'bold',
          fontSize: '12px',
          '@media (min-width:1920px)': {
            fontSize: '13px',
          },

          color: '#000000',
          '& .MuiFormLabel-asterisk': {
            color: '#ED1002',
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontWeight: 'bold',
          fontSize: '12px',
          '@media (min-width:1920px)': {
            fontSize: '13px',
          },
          color: '#000000',
          '& .MuiFormLabel-asterisk': {
            color: '#ED1002',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          border: '1px solid #D7DEE7',
        },
        root: {
          fontWeight: 600,
          '&.Mui-focused fieldset': {
            border: '1px solid #D7DEE7',
          },
          '&:hover fieldset': {
            border: '1px solid #D7DEE7',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-root': {
            height: '48px',
            padding: '8px 12px',
            fontSize: '16px',
            '@media (min-width:1920px)': {
              fontSize: '14px',
            },
            fontWeight: 400,
            borderRadius: '12px',
          },
          '& .MuiInputBase-root .MuiInputBase-input': {
            height: '48px',
            padding: 0,
          },
          '& .Mui-disabled': {
            backgroundColor: '#D7DEE7',
            color: '#7C8796',
          },
          '& .MuiInputBase-root .MuiOutlinedInput-notchedOutline': { padding: '0' },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-input': {
            fontSize: '16px',
            '@media (min-width:1920px)': {
              fontSize: '14px',
            },
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '20px',
          border: '1px solid #D9D9D9',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          backgroundColor: '#D7DEE7',
          color: '#ffffff',
          fontSize: '20px',
          fontWeight: 'bold',
          padding: '17px 30px',
          '& .MuiIconButton-root': {
            position: 'absolute',
            right: '18px',
            top: '18px',
            '& svg': {
              width: '20px',
              height: '20px',
            },
          },
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: '0 30px 20px !important',
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '10px 30px 20px !important',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 'bold',
          fontSize: '12px',
          '@media (min-width:1920px)': {
            fontSize: '13px',
          },
          height: '48px',
          borderRadius: '12px',
          padding: '10px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '10px',
          fontSize: '12px',
          '@media (min-width:1920px)': {
            fontSize: '13px',
          },
          '& *': {
            fontSize: '12px',
            '@media (min-width:1920px)': {
              fontSize: '13px',
            },
          },
          '&.MuiTableCell-paddingCheckbox': {
            padding: '3px',
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '& .MuiSvgIcon-root': {
            fontSize: '20px',
          },
        },
      },
    },
  },
});
